import React, { useState } from 'react';
import {
	AGENT_ROLES,
	AgentTypes,
	convertToAdminInitial,
	getAdminDetailsSchema,
	IAgent, initialAgentValues, SALES_ROLES
} from '../../constants/new-agent/new-agent-form';
import { useFormik } from 'formik';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useTranslation } from 'react-i18next';
import { NEW_AGENT_INFORMATION_INPUTS } from '../../constants/new-agent/new-agent-info';
import { FormInput } from '../merchants/FormInput';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { setSalesAgent } from '../../store/merchnts/actions/agents';
import { useParams } from 'react-router-dom';
import { RadioInput } from '../common/RadioInput';

interface Props {
	onSuccess: () => void;
	onError: () => void;
	agent?: IAgent;
	setChosenAgent?: (value: IAgent | null) => void;
	onCancel: () => void;
}

export const AddNewAgent = (props: Props): React.ReactElement => {
	const { onSuccess, onError, agent, setChosenAgent, onCancel } = props;
	const { t } = useTranslation();
	const { id } = useParams();
	const { merchantState: { isSavingNewSalesAgent }, dispatch } = useMerchants();
	const [agentRole, setAgentRole] = useState(agent?.contact?.role ? agent.contact?.role : SALES_ROLES.SALES_AGENCY_ADMIN);
	const formik = useFormik<AgentTypes>({
		initialValues: agent
			? convertToAdminInitial(agent)
			: initialAgentValues,
		validationSchema: getAdminDetailsSchema(t),
		onSubmit: (): Promise<void> => setSalesAgent(dispatch, formik, agent, setChosenAgent, agentRole, id, onSuccess, onError)
	});

	const emailAdditionalClasses = (): string => {
		let classNames = 'col-sm-12 col-md-12';
		if (agent?.id) {
			classNames += ' disabled';
		}
		return classNames;
	};

	const INPUTS = NEW_AGENT_INFORMATION_INPUTS({ t, emailAdditionalClasses, agent });

	return (
		<form className="row ps-7 pe-8" onSubmit={formik.handleSubmit}>

			{
				INPUTS?.map(item => (
					<FormInput
						{...item}
						formik={formik}
						key={item.key}
					/>
				))
			}

			<div>
				<div className="fs-5">
					Role
				</div>
				<div className="d-flex flex-column align-items-start justify-content-start">
					{
						AGENT_ROLES.map((role, index) => (
							<RadioInput key={`role-${index}`} {...role} currentValue={agentRole} setCurrentValue={setAgentRole}/>
						))
					}
				</div>
			</div>
			<div className="w-100 d-flex justify-content-center align-items-center px-7 py-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					onButtonClick={onCancel}
					additionalClass="me-10"
				/>

				<ButtonComponent
					buttonName="Confirm"
					type="submit"
					loading={isSavingNewSalesAgent}
					additionalClass="w-115px"
					isDisabled={isSavingNewSalesAgent}
				/>
			</div>
		</form>
	);
};
